import { FormikHelpers } from "formik";
import { useCreateDepartment } from "./api/createDepartment";
import DepartmentForm from "./DepartmentCreateForm";


const CreateDepartment = ({handleCloseModal}: CreateDepartmentProps)  => {
  const createDepartmentMutation = useCreateDepartment({data: {}});

  const initialValues: ICreateDepartmentForm = {
    description: "",
    modemID: "",
    unID: "",
    placeID: "",
    modemPort: "",
    sapCode: "",
    isEmporiki: false,
    isCiti: false
  };

  const handleSubmit = async (values: ICreateDepartmentForm, { setSubmitting }: FormikHelpers<ICreateDepartmentForm>): Promise<void> => {
    try {
      await createDepartmentMutation.mutateAsync({
        data: values,
      });
      handleCloseModal();
    } catch (error) {
      console.log(error);
      console.log("values", values);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <DepartmentForm initialValues={initialValues} onSubmit={handleSubmit} />
  )
}

interface CreateDepartmentProps {
  handleCloseModal: () => void;
}

export default CreateDepartment;